import React, { PureComponent } from "react";
import { Link } from "react-router";
import { changeLocation } from "api/Location";

import { loginRequest, batchRequest, getRequest } from "../api/ApiService";
import Auth from "../routes/Auth";
import Logo from "./assets/LandingPageLogo.png";
import EventEmitter from "../services/event-emitter";
import Teams from "../api/Teams";
import { detectMobile, getLogoStyle } from "services/utils";

class LoginPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      loginError: "",
      loginPlaceholder: "Login"
    };

    this.eventemitter = EventEmitter.getInstance();
    this.isMobile = detectMobile();
  }

  handleInputChange = e => {
    this.setState({
      loginError: "",
      [e.target.id]: e.target.value
    });
  };

  renderLoginError = () => {
    const { loginError } = this.state;

    if (loginError === "") {
      return null;
    }

    return (
      <div className="row text-center mg-top-3vh">
        <div className="col-md-4 col-md-offset-4 col-xs-12">
          <div className="alert alert-danger">
            <h4>{loginError}</h4>
          </div>
        </div>
      </div>
    );
  };

  renderActivationAlert = () => {
    const { location } = this.props;
    const { loginError } = this.state;

    if (loginError !== "") {
      return null;
    }

    if (location.query.activation) {
      return (
        <div className="row text-center mg-top-3vh">
          <div className="col-md-4 col-md-offset-4 col-xs-12">
            <div className="alert alert-info">
              <h4>
                We have sent a verify link to your email on file. Please check
                your email.
              </h4>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderVerifiedAlert = () => {
    const { location } = this.props;
    const { loginError } = this.state;

    if (loginError !== "") {
      return null;
    }

    if (location.query.verified) {
      return (
        <div className="row text-center mg-top-3vh">
          <div className="col-md-4 col-md-offset-4 col-xs-12">
            <div className="alert alert-info">
              <h4>
                Your account has been verified. You can login to continue
                working with Market Games!
              </h4>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderResetPasswordAlert = () => {
    const { location } = this.props;
    const { loginError } = this.state;

    if (loginError !== "") {
      return null;
    }

    if (location.query.reset_password) {
      return (
        <div className="row text-center mg-top-3vh">
          <div className="col-md-4 col-md-offset-4 col-xs-12">
            <div className="alert alert-info">
              <h4>
                Your password has been reset. You can login to continue working
                with Market Games!
              </h4>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  handleSubmit = () => {
    const { username, password } = this.state;
    const data = {
      username,
      password
    };

    this.setState({
      loginPlaceholder: "Login..."
    });

    loginRequest(data)
      .then(res => {
        const { token, user, position, game, course, is_paid } = res.body;

        Auth.authenticateUser(token, user, position, game, course);

        const joinRequest1 = batchRequest([Auth.getUserDataRequest()]);

        joinRequest1
          .then(res => {
            if (res[0].statusCode !== 200) {
              throw res[0];
            }

            const user_data = res[0].body;
            Auth.setUserData(user_data);

            if (position === "Student") {
              if (is_paid === false) {
                Teams.setEmptyData();

                if (this.isMobile === true) {
                  changeLocation("/promo-code");
                } else {
                  this.eventemitter.trigger("reload-data");
                  changeLocation(`/start`);
                }
              } else if (Auth.getRole() === "" || !Auth.getTeamId()) {
                Teams.setEmptyData();
                this.eventemitter.trigger("reload-data");
                changeLocation("/join");
              } else {
                const joinRequest2 = batchRequest([
                  ...Teams.requests(),
                ]);

                joinRequest2
                  .then(res2 => {
                    const teams_data = [
                      {
                        status: res2[0].statusCode,
                        data: res2[0].body
                      },
                      {
                        status: res2[1].statusCode,
                        data: res2[1].body
                      }
                    ];
                    const teams_status = Teams.setData(teams_data);
                    if (teams_status === "Error") {
                      throw teams_status;
                    }

                    getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamplayers/`)
                      .then(res3 => {
                        Auth.setPlayerRoles(res3.body.results);

                        this.eventemitter.trigger("reload-data");
                        changeLocation(`/start`);
                      })
                      .catch(err3 => {
                        console.log("Error3", err3);
                        Auth.deauthenticateUser();

                        this.setState({
                          loginPlaceholder: "Login",
                          loginError:
                            "Login details are incorrect, please try again."
                        });
                      });
                  })
                  .catch(err1 => {
                    console.log("Error1", err1);
                    Auth.deauthenticateUser();

                    this.setState({
                      loginPlaceholder: "Login",
                      loginError:
                        "Login details are incorrect, please try again."
                    });
                  });
              }
            } else if (position === "Instructor") {
              Teams.setEmptyData();
              this.eventemitter.trigger("reload-data", [() => {
                changeLocation("/start");
              }]);
            } else {
              throw res[0];
            }
          })
          .catch(err2 => {
            console.log("Error2", err2);
            Auth.deauthenticateUser();

            this.setState({
              loginPlaceholder: "Login",
              loginError: "Login details are incorrect, please try again."
            });
          });
      })
      .catch(err => {
        console.log("Error3", err);
        this.setState({
          loginPlaceholder: "Login",
          loginError: "Login details are incorrect, please try again."
        });
      });
  };

  onSubmit = e => {
    e.preventDefault();
  };

  render() {
    const { username, password, loginPlaceholder } = this.state;
    const logoStyle = getLogoStyle(this.isMobile);
    const loginError = this.renderLoginError();
    const activationAlert = this.renderActivationAlert();
    const verifiedAlert = this.renderVerifiedAlert();
    const resetPasswordAlert = this.renderResetPasswordAlert();
    const formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";

    return (
      <div className="container-fluid bg-color-blue height-100vh">
        <div className="text-center mg-top-15vh">
          <Link to="/welcome">
            <img src={Logo} style={logoStyle} alt="Logo" />
          </Link>
        </div>
        {loginError}
        {activationAlert}
        {verifiedAlert}
        {resetPasswordAlert}
        <div className={formClass}>
          <form className="form-signin" onSubmit={this.onSubmit}>
            <div className="row">
              <div className="form-group col-md-4 col-md-offset-2 col-xs-12">
                <label
                  htmlFor="username"
                  className="control-label font-size-14 color-white"
                >
                  Username
                </label>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={this.handleInputChange}
                  className="form-control border-radius-none"
                  placeholder="Username"
                  required={true}
                  autoFocus={!this.isMobile}
                />
              </div>
              <div className="form-group col-md-4 col-xs-12">
                <label
                  htmlFor="password"
                  className="control-label font-size-14 color-white"
                >
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={this.handleInputChange}
                  className="form-control border-radius-none"
                  placeholder="Password"
                  required={true}
                />
                <Link
                  to="/reset-password"
                  className="btn btn-link reset-password-link"
                >
                  Reset password
                </Link>
              </div>
            </div>
            <div className="row mg-top-3vh">
              <div className="col-md-2 col-md-offset-8 col-xs-12">
                <button
                  type="submit"
                  onClick={this.handleSubmit}
                  className="btn login-btn btn-lg btn-block"
                >
                  {loginPlaceholder}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/containers/login-page.js